module.exports = __webpack_public_path__ + "img/marker.6a014c56.png";